// Module that displays adonis errors in a UL in the form.
// TODO: It would probably be a good idea to either use a validation library for this,
// or to flesh it out more (e.g. put the error messages next to the fields).

import { FormError } from 'App/Types/ApiData';

// TODO: Use this format across the app
export const displayErrorsObject = (
  form: HTMLFormElement,
  errors: FormError[],
) => {
  let errorsWrapper = form.querySelector('.errors-wrapper');
  if (form.getAttribute('data-form') === 'contest-entry') {
    // get the errors wrapper for the step that is showing on the contest form
    errorsWrapper = form.querySelector('.js-form-step[aria-hidden="false"] .errors-wrapper');
  }
  if (!errorsWrapper) {
    console.error(errors);
    return;
  }

  // Clear previous errors
  errorsWrapper.innerHTML = '';

  // Create a UL to hold the errors
  const errorList = document.createElement('ul');
  errorList.classList.add('errors-list');
  errorsWrapper.appendChild(errorList);

  // Generate an LI for each error
  // Object.keys(errors).forEach((key) => {
  //   const li = document.createElement('li');
  //   li.textContent = `${key}: ${errors[key]}`;
  //   errorList.appendChild(li);
  // });
  if (Array.isArray(errors)) {
    errors.forEach((error) => {
      const li = document.createElement('li');
      li.innerHTML = `${error.field}: ${error.message}`;
      errorList.appendChild(li);
    });
  } else {
    Object.keys(errors).forEach((key) => {
      const li = document.createElement('li');
      li.innerHTML = `${key}: ${errors[key]}`;
      errorList.appendChild(li);
    });
  }

  form.classList.remove('loading');
  errorList.focus();
};
